import React from 'react';
import PropTypes from 'prop-types';
import { RevisorProvider } from '@weezevent/revisor-front';
import { fetcher } from '@weezevent/weezjs-core';
import { usePermissions } from 'models/user/permissions';
import i18n from '../i18n/i18n';

const revisionsFetcher = {
    get: (url, options) =>
        fetcher.get(url, { ...options, allow_cache: false, cache: false }).then(({ response }) => ({
            data: Array.isArray(response?.data) ? response.data : response
        }))
};

export function revisionRefFor(user) {
    const clientId = user?.client_id ?? user?.original_object?.client_id;
    if (clientId != null && clientId !== '') {
        return { model: 'weez:application', id: String(clientId) };
    }
    const username = String(user?.username ?? '');
    return { model: 'weez:user', id: username.startsWith('user_') ? username.slice('user_'.length) : username };
}

export function revisionRefForRole(role) {
    return { model: 'weez:role', id: String(role?.slug ?? '') };
}

export const RevisorProviderWrapper = ({ children }) => {
    const permissions = usePermissions();

    return (
        <RevisorProvider
            baseUrl={window.weezConfig.api.apiUrl}
            fetcher={revisionsFetcher}
            isAdmin={() => permissions.isAdmin()}
            locale={i18n.language}
            classNames={{ panel: 'sauron-revisor-panel' }}
        >
            {children}
        </RevisorProvider>
    );
};

RevisorProviderWrapper.propTypes = {
    children: PropTypes.node
};
